<template>
	<el-card class="box-card">
		<template #header>
			<div class="card-header">
				<span>商品尺码</span>
				<el-button class="button" @click='edit_size("")' type="success">新增尺码</el-button>
			</div>
		</template>
		<div class="col">
			<el-table empty-text="暂无数据" v-loading="loading" :data="sizeData.filter(data => !search || data.product_size_name.toLowerCase().includes(search.toLowerCase()))"
			 style="width: 100%;" :default-sort="sort" border highlight-current-row>
				<el-table-column prop="id" label="编号" sortable width="180">
				</el-table-column>
				<el-table-column label="商品尺码名称">
					<template #default="scope">
						<span>{{scope.row.product_size_name}}</span>
					</template>
				</el-table-column>
				<el-table-column label="商品尺码图片">
					<template #default="scope">
						<div v-if='scope.row.product_size_img' class="demo-image__preview">
							<el-image :src='this.getImgPrefix()+scope.row.product_size_img' style='width: 120px;' fit='contain'></el-image>
						</div>
					</template>
				</el-table-column>
				
				<el-table-column align="right">
					<template #header>
						<el-input v-model="search" size="medium" placeholder="输入商品尺码名称" />
					</template>
					<template #default="scope">
						<el-button type="primary" size="medium" @click="edit_size(scope.row)">编辑</el-button>
						<el-button v-if="this.localGet('userId')==1" type="danger" size="medium" @click="destroy(scope.$index, scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</el-card>
	<el-dialog :title="title" v-model="dialogFormVisible">
		<el-form :model="item" ref="form" :rules="rules" label-width="120px">
			<el-form-item label="商品尺码名称" prop="product_size_name">
				<el-input v-model="item.product_size_name" size="small" placeholder="商品尺码名称"></el-input>
			</el-form-item>
			<el-form-item label="商品尺码图片">
				<!-- 单文件上传 -->
				<upload buttonTitle='上传' upload_path='upload_product_size' :resize='890' @success-upload='imgSuccess_SingleFile'></upload>
				<div class="row-no-full" style="flex-wrap: wrap;">
					<div v-for="(v,i) in item.product_size_img" :key='i' style="margin-right: 30px;">
						<div class="col">
							<div class="demo-image__preview">
								<el-image :src='this.getImgPrefix()+v' style='width: 120px;' fit='contain' :preview-src-list="productSizeList"></el-image>
							</div>
							<div class="row-no-full" style="justify-content: space-around">
								<upload buttonTitle="更换" upload_path='upload_product_size' type="warning" size="mini" @success-upload='updateSizeImg'
								 :customParams="[i]"></upload>
								<div>
									<el-button type='danger' size='mini' @click='delete_size_img(i)'>删除</el-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="dialogFormVisible = false">取 消</el-button>
			<el-button type="primary" @click="submit()">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import Upload from '../common/Upload.vue'

	export default{
		name:'ProductSizeType',
		components: {
			Upload
		},
		data(){
			return {
				title: '新增尺码',
				dialogFormVisible: false,
				productSizeList:[],
				loading: true,
				sizeData:[],
				search: '',
				sort: {
					prop: 'id',
					order: 'descending'
				},
				item:{
					product_size_name:'',
					product_size_img:[],
					
				},
				rules: {
					product_size_name: [{
						required: true,
						message: '请填写商品尺码名称',
						trigger: 'blur'
					}],
				},

			}
		},
		methods: {
			edit_size(row){
				this.dialogFormVisible = true;
				let temp = this.cloneObj(row);
				// console.log(temp)
				if (row) {
					this.title = '编辑尺码';
					this.item = temp;
				} else {
					this.resetObj(this.item)
				}
				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			imgSuccess_SingleFile(e) {
				// 上传单文件
				// console.log(e);
				// console.log(this.productSizeList)
				if (this.item.product_size_img.length > 0) {
					this.item.product_size_img.splice(0, 1) //商品尺码 每次删掉前一次上传的
				}
				if (this.productSizeList.length > 0) {
					this.productSizeList.splice(0, 1) //商品尺码 展示大图 每次删掉前一次的  只保留一张图片
				}
				this.productSizeList.push(this.getImgPrefix() + e)
				this.item.product_size_img.push(e)
			},
			updateSizeImg(e, params) {
				//更换商品尺码 图片
				// console.log(e)
				// console.log(params)
				let imgSizeOldPath = this.item.product_size_img[params[0]] //更改之前的图片路径
				this.httpPost({
					url: '/admin/upload/uploadProductSizeUpdate',
					data: {
						imgSizeOldPath: imgSizeOldPath,
					}
				}).then((re) => {
					// console.log(re)
					if (re.code > 1) return this.$message.error(re.msg)
					if (this.productSizeList.length > 0) {
						this.productSizeList.splice(params[0], 1, this.getImgPrefix() + e) //商品尺码 展示大图 每次删掉前一次的  只保留一张图片
					}
					this.item.product_size_img.splice(params[0], 1, e) //点击 更换按钮后 重新给 product_size_img 赋值
				})
			
			
			},
			delete_size_img(index){
				console.log(index)
				//删除储存在服务器里的  商品尺码 图片
				let imgSizePath = this.item.product_size_img[index]
				console.log(imgSizePath)
				// return false
				if (imgSizePath) {
					this.msgBoxAjax('警告', '确定删除吗?删除后服务器图片路径也将删除', '/admin/upload/uploadProductSizeDelete', {
						imgSizePath: imgSizePath
					}).then((re) => {
						if (re.code > 1) return this.$message.error(re.msg)
						this.item.product_size_img.splice(index, 1)
					})
				} else {
					this.alertWarn('参数错误');
				}
				
			},
			destroy(index, row) {
				console.log(index, row)
				let id = row.id
				this.msgBoxAjax('警告', '确定删除吗?', '/admin/product/productSizeDelete', {
					id: id
				}).then((re) => {
					if (re.code > 1) return this.$message.error(re.msg)
					this.getProductSize()
				})
			},
			submit() {
				console.log(this.item);
				// return false;
				if(this.item.product_size_img==''){
					this.$message.error('图片未上传');
					return false;
				} 
				this.$refs['form'].validate((valid) => {
					if (valid) {

						this.httpPost({
							url: '/admin/product/productSizeUpdate',
							data: this.item
						}).then((re) => {
			
							console.log(re);
							this.dialogFormVisible = false;
							this.resetObj(this.item)
							this.getProductSize();
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				})
			
			},
			getProductSize(){
				this.httpPost({
					url: '/admin/product/productSizeList',
					data:{
						routePath: this.$route.path
					}
				}).then((re) => {
					let data = re.data
					// console.log(data)
					let temp = this.cloneObj(data);
					this.sizeData = temp;
					this.loading = false;
				
				}).catch((err) => {
					this.loading = false;
				})
			},
			
		},
		created(){
			this.getProductSize();
		}
	}
</script>

<style>
</style>
